import { TRANSPORT } from '../../service/enums.js';
import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
class AnyField extends BaseField {
    default;
    constructor(data = {}) {
        super({
            ...data,
        });
        this.proto.type = 'string';
    }
    toSchema(transport, options) {
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: ['number', 'string', 'boolean', 'object', 'array', 'null'],
            default: this.default,
        });
    }
    toJSON(input, target) {
        if (target === TRANSPORT.GRPC) {
            return JSON.stringify(input);
        }
        return input;
    }
    fromJSON(input) {
        return input;
    }
    fromProto(input) {
        return input === undefined ? input : JSON.parse(input);
    }
}
export default AnyField;
//# sourceMappingURL=AnyField.js.map